import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {URLS} from '../../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class SingleOrderService {

  constructor(private http: HttpClient) { }

  SeaRatesContainer(containerid) {
    return this.http.get(URLS.API + 'searates/container', {params: {number: containerid}, withCredentials: true});
  }
  SeaRatesRoute(containerid) {
    return this.http.get(URLS.API + 'searates/route', {params: {number: containerid}, withCredentials: true});
  }


  getVesselFinderRoute(ShipmentID , StartDate){
    return this.http.get(URLS.API + 'vesselfinder/route', {params: {ShipmentID : ShipmentID }, withCredentials: true});
  }

  getOrderMessages(orderId){
    return this.http.get(URLS.API + 'orders/conversation', {params: { id: orderId }, withCredentials: true});
  }
}
